import type { LucideIcon } from 'lucide-react'
import { Card, CardContent } from '@/components/ui/card'
import { formatCompact } from '@/lib/format'

interface StatTileProps {
  label: string
  value: number
  icon: LucideIcon
  suffix?: string
}

export function StatTile({ label, value, icon: Icon, suffix = '' }: StatTileProps) {
  return (
    <Card className="gap-2 py-5">
      <CardContent className="flex items-center gap-4 px-5">
        <div className="flex size-10 shrink-0 items-center justify-center rounded-full bg-primary/10 text-primary">
          <Icon className="size-5" strokeWidth={2} />
        </div>
        <div className="flex flex-col">
          <span className="text-2xl font-semibold tracking-tight">
            {formatCompact(value)}
            {suffix}
          </span>
          <span className="text-sm text-muted-foreground">{label}</span>
        </div>
      </CardContent>
    </Card>
  )
}
